import { defineComponent as _defineComponent } from 'vue'
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import CcRequestFeatureModal from '@/views/Automation/CampaignCreatorV2/components/Modals/CcRequestFeatureModal.ts.vue';
import { ref } from 'vue';

interface Props {
  featureId: string;
  modalTitle: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RequestFeature.ts',
  props: {
    featureId: null,
    modalTitle: null
  },
  setup(__props: any) {

const isRequestModalOpen = ref(false);



return { __sfc: true,isRequestModalOpen, CcIcon, CcRequestFeatureModal }
}

})